module.exports = __webpack_public_path__ + "47dd0133cbfd6cabf0ea001eb99a45b4.jpg";